(ns entities.partner.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    )
  )

(def path [:entities :partner])

(rf/reg-entity
  :partner
  {:get
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/partner data)
                :name :partner
                :success [:partner/fetched]
                :error [:partner/fetch-errored]
                :allow-unauth? true
                }})})

(rf/reg-event-db
  :partner/fetched
  (rf/path path)
  (fn [_ [data]]
    (:partner data)))
